// Message bubbles for Ask Hopscotch.
// Assistant messages can include an action button that bridges chat to product.

import { AskMark } from './AskMark';
import type { ChatMessage } from '@/types';
import './styles/MessageBubbles.css';import { CssVarSpan } from "@/components/CssVarElements";

export function AssistantMsg({
  message,
  onAction



}: {message: ChatMessage;onAction: (msg: ChatMessage) => void;}) {
  const action = message.action;

  return (
    <div className="message-bubbles__assistant">
      <div className="message-bubbles__assistant-header">
        <AskMark size={18} />
        <span className="message-bubbles__eyebrow">Hopscotch</span>
      </div>

      {message.content ?
      <div className="message-bubbles__assistant-bubble">{message.content}</div> :

      <TypingDots />
      }

      {action &&
      <button
        type="button"
        onClick={() => onAction(message)}
        disabled={action.status === 'done'}
        className="hs-press hs-press--paper message-bubbles__action-button">

          <svg
          width="15"
          height="15"
          viewBox="0 0 20 20"
          className="message-bubbles__action-icon">

            <path d="M10 5C8 3.5 5 3.5 3 4v12c2-.5 5-.5 7 1 2-1.5 5-1.5 7-1V4c-2-.5-5-.5-7 1zM10 5v13" />
          </svg>
          {action.status === 'done' ? 'On it!' : action.label}
        </button>
      }
    </div>);

}

export function UserMsg({ message }: {message: ChatMessage;}) {
  return <div className="message-bubbles__user">{message.content}</div>;
}

function TypingDots() {
  return (
    <div className="message-bubbles__typing">
      {[0, 150, 300].map((delay) =>
      <CssVarSpan
        key={delay}
        className="animate-bounce message-bubbles__typing-dot"
        cssVars={{ animationDelay: `${delay}ms` }} />

      )}
    </div>);

}